// extracted by mini-css-extract-plugin
export default {"root":"ReJQDyESoibz7_z69SEP"};